namespace Matrix.Administration {

    @Serenity.Decorators.registerClass()
    export class GroupGrid extends SiteEntityGrid<GroupRow, any> {
        protected getColumnsKey() { return "Administration.Group"; }
        protected getDialogType() { return GroupDialog; }
        protected getIdProperty() { return GroupRow.idProperty; }
        protected getLocalTextPrefix() { return GroupRow.localTextPrefix; }
        protected getService() { return GroupService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getColumns() {
            var columns = super.getColumns();

            var roles = Q.tryFirst(columns, x => x.field == GroupRow.Fields.Roles);
            if (roles) {
                roles.format = ctx => {
                    var roleNames = (ctx.value || []).map(x => (RoleRow.getLookup().itemById[x] || {}).RoleName || "");
                    roleNames.sort();
                    return roleNames.join(", ");
                };
            }

            return columns;
        }
    }
}